<template>
    <svg width="20" height="20" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_6367_244)">
        <path d="M5.4165 8.33325H3.74984V14.1666H5.4165V8.33325ZM10.4165 8.33325H8.74984V14.1666H10.4165V8.33325ZM17.4998 15.8333H1.6665V17.4999H17.4998V15.8333ZM15.4165 8.33325H13.7498V14.1666H15.4165V8.33325ZM9.58317 2.71659L13.9248 4.99992H5.2415L9.58317 2.71659ZM9.58317 0.833252L1.6665 4.99992V6.66658H17.4998V4.99992L9.58317 0.833252Z" fill="black"/>
    </g>
    
    <defs>
        <clipPath id="clip0_6367_244">
            <rect width="20" height="20" fill="white"/>
        </clipPath>
    </defs>
    </svg>
</template>
